<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import V4Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['download']);

const { t } = useI18n();

const isOpen = ref(false);

const menuItems = [
  { action: 'csv', value: 'csv', label: 'CSV', icon: 'i-ph-file-csv' },
  { action: 'xlsx', value: 'xlsx', label: 'XLSX', icon: 'i-ph-file-xls' },
];

const toggle = () => {
  isOpen.value = !isOpen.value;
};

const close = () => {
  isOpen.value = false;
};

const handleAction = ({ value }) => {
  emit('download', value);
  close();
};
</script>

<template>
  <div v-on-clickaway="close" class="relative">
    <V4Button
      :label="t('REPORT.DOWNLOAD_REPORT')"
      icon="i-ph-download-simple"
      size="sm"
      :disabled="disabled"
      @click="toggle"
    />
    <DropdownMenu
      v-if="isOpen"
      :menu-items="menuItems"
      class="ltr:right-0 rtl:left-0 mt-1 top-full min-w-32"
      @action="handleAction"
    />
  </div>
</template>
